import React, { useCallback } from 'react';

import { shallowEqual, useSelector } from 'react-redux';
import { selectAddToAgendaState } from 'selectors/addToAgendaStateSelector';
import { Divider1 } from 'styles/common';

import { useLevelUpContext } from '../context';
import CompetencyRow from './CompetencyRow';

const CompetencyList = ({ levelUpId, jobFunctionId, jobRoleId, competencies }) => {
  const { handleCompetencyTargetDateChange, handleCompetencyProgressStatusChange } = useLevelUpContext();

  const { showAddToAgenda } = useSelector(selectAddToAgendaState, shallowEqual);

  const handleTargetDateChange = useCallback(
    ({ competencyId, targetPeriodStart, subComptencyId = null }) => {
      handleCompetencyTargetDateChange({
        jobFunctionId,
        jobRoleId,
        competencyId,
        targetPeriodStart,
        subComptencyId,
      });
    },
    [jobFunctionId, jobRoleId, handleCompetencyTargetDateChange]
  );

  const handleProgressStatusChange = useCallback(
    ({ competencyId, status, subComptencyId = null }) => {
      handleCompetencyProgressStatusChange({
        jobFunctionId,
        jobRoleId,
        competencyId,
        status,
        subComptencyId,
      });
    },
    [jobFunctionId, jobRoleId, handleCompetencyProgressStatusChange]
  );

  return (
    <>
      {competencies.map(
        ({
          competencyId,
          name,
          targetPeriodStart,
          subCompetencies,
          status,
          competencyStatus,
          progressBar,
          progress,
        }) => (
          <React.Fragment key={competencyId}>
            <CompetencyRow
              levelUpId={levelUpId}
              competencyId={competencyId}
              name={name}
              targetPeriodStart={targetPeriodStart}
              subCompetencies={subCompetencies}
              handleTargetDateChange={handleTargetDateChange}
              handleProgressStatusChange={handleProgressStatusChange}
              showAddToAgenda={showAddToAgenda}
              status={status}
              competencyStatus={competencyStatus}
              progressBar={progressBar}
              progress={progress}
            />
            <Divider1 leftGutter={3} rightGutter={3} />
          </React.Fragment>
        )
      )}
    </>
  );
};

export default CompetencyList;
